import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout kicker="LEGAL" title="Terms of Service">
      <p>By using Qontri, you agree to these Terms of Service.</p>

      <h2>Use of Service</h2>
      <p>
        Qontri provides tools for tracking shared expenses and managing
        settlements among individuals and groups.
      </p>
      <p>You agree not to:</p>
      <ul>
        <li>Violate any applicable laws</li>
        <li>Attempt unauthorized access to the service</li>
        <li>Use the service for fraudulent activities</li>
      </ul>

      <h2>User Content</h2>
      <p>
        Users are responsible for the accuracy of the information they enter
        into the platform.
      </p>

      <h2>Availability</h2>
      <p>
        We strive to keep the service available but do not guarantee
        uninterrupted access.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Qontri is provided on an "as is" basis. We are not responsible for
        losses arising from the use of the service.
      </p>

      <h2>Termination</h2>
      <p>We may suspend or terminate accounts that violate these terms.</p>

      <h2>Changes</h2>
      <p>
        We may update these Terms from time to time. Continued use of the
        service constitutes acceptance of any updates.
      </p>

      <h2>Contact</h2>
      <p>
        Questions regarding these Terms may be sent to:{" "}
        <a href="mailto:support@qontri.in">support@qontri.in</a>
      </p>
    </LegalLayout>
  );
}
